import { render, staticRenderFns } from "./CCheckbox.vue?vue&type=template&id=8fa95b74"
import script from "./CCheckbox.vue?vue&type=script&lang=js"
export * from "./CCheckbox.vue?vue&type=script&lang=js"
import style0 from "./CCheckbox.vue?vue&type=style&index=0&id=8fa95b74&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8fa95b74')) {
      api.createRecord('8fa95b74', component.options)
    } else {
      api.reload('8fa95b74', component.options)
    }
    module.hot.accept("./CCheckbox.vue?vue&type=template&id=8fa95b74", function () {
      api.rerender('8fa95b74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CCheckbox.vue"
export default component.exports